<template>
    <Card3 colClass="col-xl-12" pre="true" preClass="f-m-light mt-1" headerTitle="true" :title="title" :desc="desc">
        <div class="row shopping-wizard">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row shipping-form g-5">
                    <div class="col-xl-9 shipping-border">
                        <div class="nav nav-pills horizontal-options shipping-options" id="cart-options-tab" role="tablist" aria-orientation="vertical">
                          <a class="nav-link b-r-0" v-for="(item, index) in forms" :key="index"
                            :id="item.id" data-bs-toggle="pill" :href="item.href" role="tab"
                            aria-controls="preparation"
                            v-bind:class="{ 'active': isActiveTab(item.id, route.params.type) }"
                            aria-selected="true"
                            @click.prevent="changeType(item.id)">
                            <div class="cart-options">
                              <div class="stroke-icon-wizard"><i class="fa" :class="item.icon"></i></div>
                              <div class="cart-options-content">
                                <h6>{{ item.label }}</h6>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div class="tab-content dark-field shipping-content" id="cart-options-tabContent">
                          <component :is="getActiveComponent(route.params.type)"/>
                        </div>
                    </div>
                    <FormProductList ref="formProductListRef" />
                </div>
            </div>
        </div>
    </Card3>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { forms } from "@/core/data/forms"
import { useRoute , useRouter} from "vue-router"
const router = useRouter();
const route = useRoute();
const title = ref(null)
const formProductListRef = ref(null)
const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const FormProductList = defineAsyncComponent(() => import("@/components/theme/forms/FormProductList.vue"))

const FormPreparation = defineAsyncComponent(() => import("@/components/theme/forms/FormPreparation.vue"))
const FormProductCheckList = defineAsyncComponent(() => import("@/components/theme/forms/FormProductCheckList.vue"))
const FormDelivery = defineAsyncComponent(() => import("@/components/theme/forms/FormDelivery.vue"))
const FormInstall = defineAsyncComponent(() => import("@/components/theme/forms/FormInstall.vue"))
const FormAdditionalProduct = defineAsyncComponent(() => import("@/components/theme/forms/FormAdditionalProduct.vue"))

// Function to refresh the product list when equipment is added
const refreshProductList = () => {
  if (formProductListRef.value && formProductListRef.value.fetchData) {
    formProductListRef.value.fetchData();
  }
}

// Expose the refresh function for child components
defineExpose({
  refreshProductList
});

function changeType(type) {
  let routeType;
  switch (type) {
    case 'preparation-tab':
      routeType = 'preparation';
      break;
    case 'preparation-check-tab':
      routeType = 'checklist';
      break;
    case 'shipping-info-tab':
      routeType = 'delivery';
      break;
    case 'installation-info-tab':
      routeType = 'install';
      break;
    case 'additional-info-tab':
      routeType = 'additional-info';
      break;
    default:
      routeType = 'preparation';
  }
  
  router.push({
    name: route.name,
    params: { ...route.params, type: routeType }
  });
}

function isActiveTab(tabId, routeType) {
  let expectedTabId;
  switch (routeType) {
    case 'preparation':
      expectedTabId = 'preparation-tab';
      title.value = "การเตรียมสินค้า";
      break;
    case 'checklist':
      expectedTabId = 'preparation-check-tab';
      title.value = "รายการตรวจสอบ";
      break;
    case 'delivery':
      expectedTabId = 'shipping-info-tab';
      title.value = "ข้อมูลการจัดส่ง";
      break;
    case 'install':
      expectedTabId = 'installation-info-tab';
      title.value = "ข้อมูลการติดตั้ง";
      break;
    case 'additional-info':
      expectedTabId = 'additional-info-tab';
      title.value = "อุปกรณ์เพิ่มเติม";
      break;
    default:
      expectedTabId = 'preparation-tab';
      title.value = "การเตรียมสินค้า";
  }
  return tabId === expectedTabId;
}

function getActiveComponent(type) {
  switch (type) {
    case 'preparation': return FormPreparation;
    case 'checklist': return FormProductCheckList;
    case 'delivery': return FormDelivery;
    case 'install': return FormInstall;
    case 'additional-info': return FormAdditionalProduct;
    default: return FormPreparation;
  }
}
</script>